import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { observer, inject } from 'mobx-react'
import { Layout, PageHeader, Row, Col, Input, Select, Button, Form, List, Card } from 'antd'

import SynonymItem from './SynonymItem'
import SearchItem from './SearchItem'
import DoctorsInfo from './DoctorsInfo'
import CollectionsInfo from './CollectionsInfo'
import ClinicsInfo from './ClinicsInfo'
@inject((store: any) => {
    const { synonymsStore, doctorsStore, clinicsStore, collectionsStore } = store
    return { synonymsStore, doctorsStore, clinicsStore, collectionsStore }
})
@observer
class Search extends Component<any, any> {
    state = {
        searchType: undefined,
        currentSearch: null,
        keywords: null,
        total: 0,
        page: 1,
        list: [],
        error: null
    }
    async componentDidMount() {
        this.resetSearch()
        await this.props.synonymsStore.resetSynonyms()
    }
    searchDoctors = async () => {
        const { page, keywords } = this.state
        await this.props.doctorsStore.search({ page, keywords })
        const { list, paging } = this.props.doctorsStore
        this.setState({ list, total: paging.total })
    }
    searchClinics = async () => {
        const { page, keywords } = this.state
        await this.props.clinicsStore.search({ page, keywords })
        const { list, paging } = this.props.clinicsStore
        this.setState({ list, total: paging.total })
    }
    searchCollections = async () => {
        const { page, keywords } = this.state
        await this.props.collectionsStore.search({ page, keywords })
        const { list, paging } = this.props.collectionsStore
        this.setState({ list, total: paging.total })
    }
    handleChangePage = async page => {
        await this.setState({ page })
        this.handleSubmitSearch()
    }
    handleChangeSearch = searchType => {
        this.setState({ searchType })
    }
    handleChangeSearchTerm = keywords => {
        this.setState({ keywords })
    }
    handleSubmitSearch = () => {
        const { searchType, keywords } = this.state
        if (!!keywords && searchType) {
            this.setState({ error: null, currentSearch: keywords })
            this.props.synonymsStore.search(keywords)
            if (searchType === 'doctors') {
                this.searchDoctors()
            } else if (searchType === 'clinics') {
                this.searchClinics()
            } else if (searchType === 'collections') {
                this.searchCollections()
            }
        } else if (!keywords) {
            this.setState({ error: 'עליך להזין מילות חיפוש', list: [], page: 1, total: 0, currentSearch: null })
        } else if (!searchType) {
            this.setState({ error: 'עליך לבחור את סוג החיפוש', list: [], page: 1, total: 0, currentSearch: null })
        }
    }

    resetSearch = () => {
        this.setState({ error: null, list: [], page: 1, total: 0, currentSearch: null })
    }

    render() {
        const { searchType, total, list, keywords, error, page, currentSearch } = this.state
        const searchFor = {
            doctors: 'רופאים',
            clinics: 'מרפאות',
            collections: 'זכויות'
        }

        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="חיפוש חופשי במערכת"
                    subTitle="ממשק לבדיקת החיפוש החופשי במערכת"
                />
                <Form
                    onSubmit={e => {
                        e.preventDefault()
                        this.handleChangePage(1)
                    }}
                >
                    <Row gutter={10} style={{ padding: '0 2rem' }}>
                        <Col xs={4}>
                            <Select
                                style={{ width: '100%' }}
                                onChange={e => {
                                    this.handleChangeSearch(e)
                                    this.handleChangePage(1)
                                }}
                                value={searchType}
                                placeholder="בחר את סוג המידע שברצונך לחפש"
                            >
                                <Select.Option key="doctors" value="doctors">
                                    חיפוש רופאים
                                </Select.Option>
                                <Select.Option key="clinics" value="clinics">
                                    חיפוש מרפאות
                                </Select.Option>
                                <Select.Option key="collections" value="collections">
                                    חיפוש זכויות
                                </Select.Option>
                            </Select>
                        </Col>
                        <Col xs={18}>
                            <Input.Search
                                onChange={e => this.handleChangeSearchTerm(e.target.value)}
                                placeholder="הזן ערך לחיפוש"
                                value={keywords}
                            />
                        </Col>
                        <Col xs={2}>
                            <Button htmlType="submit" style={{ width: '100%' }}>
                                חפש
                            </Button>
                        </Col>
                    </Row>
                </Form>
                <Row gutter={10} style={{ padding: '0 2rem' }}>
                    <Col>{error && <span style={{ color: 'red', fontWeight: 'bold' }}>* {error}</span>}</Col>
                </Row>
                <Row style={{ padding: '0 2rem', margin: '1rem 0' }} gutter={10}>
                    <Col xs={16}>
                        <Card
                            type="inner"
                            title={
                                <strong style={{ fontSize: '1.1rem' }}>
                                    {total > 0
                                        ? `נמצאו ${total} ${searchFor[searchType]} עבור "${currentSearch}"`
                                        : 'אין תוצאות'}
                                </strong>
                            }
                        >
                            <List
                                dataSource={list}
                                pagination={{
                                    pageSize: 10,
                                    total,
                                    current: page,
                                    hideOnSinglePage: true,
                                    onChange: e => {
                                        this.handleChangePage(e)
                                    }
                                }}
                                renderItem={item => {
                                    const moreInfo = {
                                        doctors: <DoctorsInfo {...item} />,
                                        clinics: <ClinicsInfo {...item} />,
                                        collections: <CollectionsInfo {...item} />
                                    }
                                    return (
                                        <List.Item key={item['id']} style={{ padding: '0.4rem' }}>
                                            <SearchItem {...item} moreInfo={moreInfo[searchType]} />
                                        </List.Item>
                                    )
                                }}
                            />
                        </Card>
                    </Col>
                    <Col xs={8}>
                        <Card
                            type="inner"
                            title={<strong style={{ fontSize: '1.1rem' }}>קבוצות המושגים שנמצאו</strong>}
                        >
                            <List
                                dataSource={list.length > 0 ? this.props.synonymsStore.list : []}
                                renderItem={item => {
                                    return (
                                        <List.Item key={item['id']} style={{ padding: '0.4rem' }}>
                                            <SynonymItem {...item} />
                                        </List.Item>
                                    )
                                }}
                            />
                        </Card>
                    </Col>
                </Row>
            </Layout>
        )
    }
}

export default withRouter(Search)
